export const CCS_CONNECT_TO_WEBSOCKET_REQUEST = "CCS_CONNECT_TO_WEBSOCKET_REQUEST"
export const CCS_UPLOAD_FILES_REQUEST = "CCS_UPLOAD_FILES_REQUEST"
export const CCS_ADD_TO_MESSAGE_QUEUE_REQUEST = "CCS_ADD_TO_MESSAGE_QUEUE_REQUEST"
export const CCS_UPLOAD_FILES_FAILURE = "CCS_UPLOAD_FILES_FAILURE"
export const CCS_UPLOAD_FILES_SUCCESS = "CCS_UPLOAD_FILES_SUCCESS"
export const CCS_ADD_TO_MESSAGE_QUEUE_SUCCESS = "CCS_ADD_TO_MESSAGE_QUEUE_SUCCESS"